// Sidebar entries owned by the Account module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { accountPaths } from './paths'

export const accountNav = {
    profile: {
        title: 'account',
        path: accountPaths.account,
    },
    oncall: {
        title: 'account:oncall',
        path: accountPaths.accountOncall,
    },
    myIncomes: {
        title: 'account:my_incomes',
        path: accountPaths.accountMyIncomes,
    },
    myRatings: {
        title: 'my-ratings',
        path: accountPaths.accountMyRatings,
    },
    // Khai rsname + require_scopes là thứ DUY NHẤT ẩn được tab với role khác:
    // Sidebar/Menu/Item/index.tsx bỏ qua kiểm quyền khi thiếu một trong hai.
    // Chọn 'create' chứ không 'index' — CSKH nằm ở nhánh write, lấy 'index'
    // sẽ ẩn mất đúng nhóm cần dùng.
    calendarEvents: {
        title: 'customer:calendar_events.sidebar_title',
        path: accountPaths.accountCustomerEvents,
        rsname: 'Customers',
        require_scopes: ['create'],
        visible_permission_denied: false,
    },
} satisfies Record<string, SidebarType>
